import { ReactElement } from 'react'

interface Props {
  axis: 'y' | 'z'
}

/** The eccentricity symbol with its axis as index, e.g. e with subscript z. */
const EccentricitySymbol = ({ axis }: Props): ReactElement => (
  <span>
    e<sub>{axis}</sub>
  </span>
)

export default EccentricitySymbol
